import React, { Fragment } from 'react';
import { BooleanField } from './fields/BooleanField';
import { NumberField } from './fields/NumberField';
import { StringField } from './fields/StringField';
import { IBFProductVariable } from 'Services/widgets/interfaces';
import { DateField } from './fields/DateField';
import {
  FIELD_TYPE_BOOL,
  FIELD_TYPE_NUMBER,
  FIELD_TYPE_STRING,
  FIELD_TYPE_DATETIME,
  CFDefaultValueType,
} from '../bf-hooks';

export interface BaseElementProps {
  valField: CFDefaultValueType;
  variable: IBFProductVariable;
  showTooltip: ( isShow: boolean, tooltip: string ) => void;
}

export const BaseElement: React.FC<BaseElementProps> = ( { valField, variable, showTooltip } ) => {

  return (
    <Fragment>
      { variable.typeId === FIELD_TYPE_STRING && (
        <StringField valueField={ valField } variable={ variable } showTooltip={ showTooltip } />
      ) }
      { variable.typeId === FIELD_TYPE_DATETIME && (
        <DateField valueField={ valField } variable={ variable } showTooltip={ showTooltip } />
      ) }
      { variable.typeId === FIELD_TYPE_NUMBER && (
        <NumberField valueField={ valField } variable={ variable } showTooltip={ showTooltip } />
      ) }
      { variable.typeId === FIELD_TYPE_BOOL && (
        <BooleanField valueField={ valField } variable={ variable } showTooltip={ showTooltip } />
      ) }
    </Fragment>
  );
};
